!function (global) {
    'use strict';

    // Variables
    // =========

    var DEFAULTS = {
        easing: function (x) {
            return x * (2 - x);
        },
        interrupt: false,
        horizontal: false,
        duration: 400,
        onComplete: false
    };

    var UID = '_scrollerID';

    // Polyfills
    // =========

    var sign = Math.sign || function (value) {
            return value > 0 ? 1 : value < 0 ? -1 : 0;
        };

    var assign = Object.assign
        ? Object.assign
        : function (target, source) {
            var obj = Object(target);
            var number;
            var index;
            var keys;
            var key;
            var descriptor;

            for (number = 0; number < arguments.length; number++) {
                source = arguments[number];

                if (source === undefined || source === null) {
                    continue;
                }

                keys = Object.keys(Object(source));

                for (index = 0; index < keys.length; index++) {
                    key = keys[index];

                    descriptor = Object.getOwnPropertyDescriptor(source, key);

                    if (descriptor !== undefined && descriptor.enumerable) {
                        obj[key] = source[key];
                    }
                }
            }
            return obj;
        };

    var requestAnimationFrame = function () {
        var requestAnimationFrame = global.requestAnimationFrame;
        var vendors;
        var index;
        var lastTime;

        if (!requestAnimationFrame) {
            vendors = ['ms', 'moz', 'webkit', 'o'];

            for (index = 0; index < vendors.length && !requestAnimationFrame; ++index) {
                requestAnimationFrame = global[vendors[index] + 'RequestAnimationFrame'];
            }
        }

        if (!requestAnimationFrame) {
            lastTime = 0;

            requestAnimationFrame = function (callback) {
                var currentTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currentTime - lastTime));

                lastTime = currentTime + timeToCall;

                return global.setTimeout(function () {
                    callback(currentTime + timeToCall);
                }, timeToCall);
            };
        }

        return requestAnimationFrame;
    }();

    // Scroller
    // ========

    function Scroller(element) {
        this.element = element;

        this.queue = [];
        this.pending = false;
        this.direction = 0;
        this.horizontal = false;

        if (element === global) {
            this.scrollX = function (delta) {
                element.scrollBy(delta, 0);
            };
            this.scrollY = function (delta) {
                element.scrollBy(0, delta);
            };
        } else {
            this.scrollX = function (delta) {
                element.scrollLeft += delta;
            };

            this.scrollY = function (delta) {
                element.scrollTop += delta;
            };
        }
    }

    Scroller.prototype.scroll = function (delta, options) {
        options = assign({}, DEFAULTS, options);

        var scroller = this;
        var index;
        var item;
        var direction = sign(delta);
        var scroll = options.horizontal ? scroller.scrollX : scroller.scrollY;

        if (scroller.direction !== direction || scroller.horizontal !== options.horizontal) {
            scroller.direction = direction;

            for (index = 0; index < scroller.queue.length; index++) {
                scroller.queue[index].complete();
            }

            scroller.queue = [];
        }

        scroller.queue.push({
            delta: delta,
            last: -0.99 * direction,
            start: +new Date,
            complete: typeof options.onComplete === 'function' ? options.onComplete : Function
        });

        if (scroller.pending) {
            return;
        }

        var animationStep = function () {
            var queue = scroller.queue;
            var now = +new Date;
            var elapsed;
            var finished;
            var progress;
            var fullDelta = 0;
            var index;
            var item;
            var itemDelta;

            for (index = 0; index < queue.length; index++) {

                item = queue[index];
                elapsed = now - item.start;
                finished = elapsed >= options.duration;

                progress = finished ? 1 : options.easing(elapsed / options.duration);

                itemDelta = (item.delta * progress - item.last) | 0;

                item.last += itemDelta;
                fullDelta += itemDelta;

                if (finished) {
                    item.complete();

                    queue.splice(index, 1);
                    index--;
                }
            }

            scroll(fullDelta);

            if (queue.length) {
                requestAnimationFrame(animationStep);
            } else {
                scroller.pending = false;
            }
        };

        requestAnimationFrame(animationStep);
        scroller.pending = true;
    };


    // Scroller Manager
    // ================

    function ScrollerManager() {
        this.storage = {};
        this.id = 0;
    }

    ScrollerManager.prototype.get = function (element) {
        var manager = this;
        var storage = manager.storage;
        var id = element[UID];
        var scroller = storage[id];

        if (!id) {
            element[UID] = id = ++manager.id;
        }

        if (!scroller) {
            scroller = storage[id] = new Scroller(element);
        }

        if (typeof scroller.remove === 'number') {
            global.clearTimeout(scroller.remove);
        }

        scroller.remove = setTimeout(function () {
            delete storage[id];
        }, 5e3);

        return storage[id];
    };

    var scrollerManager = new ScrollerManager();


    // Exports
    // =======

    /**
     * Smooth scroll element
     *
     * @param element
     * @param delta
     * @param options
     */
    global.smoothScroll = function (element, delta, options) {
        scrollerManager.get(element).scroll(delta, options);
    };

}(window);
